module.exports = __webpack_public_path__ + "media/your_career_track/construction-manager-hover-a9abfa77.png";